var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttempted = function SvgAttempted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.493 4.417 7.939 13.75a.833.833 0 0 1-.722 1.25H3.833a.834.834 0 0 1-.721-1.25l7.938-13.75a.833.833 0 0 1 1.443 0ZM5.277 17.75h12.99L11.772 6.5 5.277 17.75Zm5.661-2.5h1.667v1.667h-1.667V15.25Zm0-5.833h1.667v4.166h-1.667V9.417Z",
    fill: "#959799"
  })));
};
export default SvgAttempted;